import { Spacer, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useTranslate } from 'src/hooks';
import ManualTopupTransactionModal from 'src/pages/TransactionReport/AccountStatement/components/MainCard/components/ManualTopupTransactionModal/ManualTopupTransactionModal';
import numeral from 'src/utilities/numeral';
import { ErrorBoundary } from '../../../ErrorBoundary';
import { BalanceTooltip } from '../BalanceTooltip/BalanceTooltip';
import styles from '../Sidebar.module.css';
import { useBalanceSectionImpl } from './useBalanceSectionImpl';

export const BalanceSection = () => {
  const {
    availableBalance,
    balanceDetails,
    color,
    isSidebarCollapsed,
    showBalance,
    showTooltip,
    setShowTooltip,
    toggleBalance,
  } = useBalanceSectionImpl();
  const { getTranslation } = useTranslate();

  return (
    <Spacer bottom={Spacer.Size.XL}>
      <Text
        textStyle={Text.Style.BodySmRegular}
        color={color}
        className={styles.balanceLabel}
        onClick={toggleBalance}
      >
        {getTranslation('common_availableBalance')}
        <SystemIcon
          name={showBalance ? 'eye' : 'eye-slash'}
          size={16}
          color={color}
        />
      </Text>
      <span
        role="button"
        id="menuDetailBalance"
        className={styles.balanceButton}
      >
        {isSidebarCollapsed ? (
          <SystemIcon name="rupiah" size={24} color={color} />
        ) : (
          <>
            <Text textStyle={Text.Style.HeadingSm} color={color}>
              {showBalance
                ? numeral(Math.floor(availableBalance)).format('$0,0')
                : getTranslation('common_secret_rupiah')}
            </Text>
            <SystemIcon name="arrow-down" size={16} color={color} />
          </>
        )}
      </span>
      <ErrorBoundary domain="dashboard" componentName="BalanceTooltip">
        <BalanceTooltip
          balanceDetails={balanceDetails}
          setShowTooltip={setShowTooltip}
          showTooltip={showTooltip}
        />
      </ErrorBoundary>

      <ErrorBoundary
        domain="dashboard"
        componentName="ManualTopupTransactionModal"
      >
        <ManualTopupTransactionModal />
      </ErrorBoundary>
    </Spacer>
  );
};
